import React from 'react';
import {
  Toggle,
  TextField,
  Styles,
  FlatButton,
  Paper,
  LinearProgress
} from 'material-ui';
import FileSelectorDialog from 'components/Widgets/FileSelectorDialog';
import DropZone from 'components/DropZone';
import { FormattedMessage } from 'react-intl';
import dropZoneStyles from 'components/Page/Module/Styles';
import CircularProgress from 'components/Material/CircularProgress';
import { FlexBox } from 'components';
import Embed from 'components/Page/Module/Embed';
import VideoPlayer from 'components/Widgets/VideoPlayer';
import SteelCompass from 'services/SteelCompass';
import SuperAgent from 'superagent';
import Config from 'Config';
import * as Icons from 'components/Material/SvgIcons';
import PageModule from 'components/PageModule';
import { Media } from 'Util';
import SoundCloud from 'services/SoundCloud';
import Message from 'services/Message';
import { Units } from 'Css';
const { Spacing } = Styles;

const supportedExtensions = ['mp4', 'ogv'];
// const oldExtensions = ['mp4', 'ogv', 'ogg'];

const css = oxygenCss({
  toggleWrapper: {
    padding: `${Units.base}px ${Units.base * 3}px`
  },
  videoDownload: {
    padding: Units.base
  },
  downloadLink: {
    margin: `0 ${Units.base}px`
  }
});

class VideoModule extends PageModule {
  static readable = 'VideoModule';

  constructor() {
    super(...arguments);
    const { content, params } = this.props;
    const { caption, external, allowDownloading } = params;
    let file;
    let sources;
    if (content.length && content.length > 0) {
      file = content[0];

      sources =
        (file &&
          supportedExtensions.map(extension => {
            return { url: file.url, type: extension };
          })) ||
        [];
    } else if (
      params &&
      typeof params === 'object' &&
      Object.keys(params).length > 0 &&
      !params.external &&
      (!params.file_id || params.file_id.length < 1)
    ) {
      sources = Object.keys(params).map(extension => {
        /*const tokens = params[extension].split('.');
        tokens.pop();*/
        return { url: params[extension], type: extension };
      });
    }
    this.state = {
      edit: {
        sources,
        external,
        caption,
        allowDownloading
      }
    };
  }

  isFullscreen() {
    return !window.screenTop && !window.screenY;
  }

  handleFullScreen = event => {
    const fullscreen = this.isFullscreen();
    if (!fullscreen) {
      this.refs.root.scrollIntoView(true);
    }
  };

  componentDidMount() {
    document.addEventListener(
      'webkitfullscreenchange',
      this.handleFullScreen,
      false
    );
    document.addEventListener(
      'mozfullscreenchange',
      this.handleFullScreen,
      false
    );
    document.addEventListener('fullscreenchange', this.handleFullScreen, false);
  }

  componentWillMount() {
    document.removeEventListener(
      'webkitfullscreenchange',
      this.handleFullScreen
    );
    document.removeEventListener('mozfullscreenchange', this.handleFullScreen);
    document.removeEventListener('fullscreenchange', this.handleFullScreen);
  }

  autoSave() {
    if (this._timer) {
      clearTimeout(this._timer);
    }
    this._timer = setTimeout(() => {
      Message.info(this.context.getIntlMessage('video.changesSaved'));
      this.save(false);
      this._timer = null;
    }, 1000);
  }

  selectMedia(file) {
    const sources = supportedExtensions.map(extension => {
      return { url: file.url, type: extension };
    });
    const edit = {
      ...this.state.edit,
      fileId: file.id,
      external: null,
      sources
    };
    this.setState({ edit, fileSelectorOpen: false });
    this.autoSave();
  }

  progress(event) {
    this.setState({ progress: event.percent });
  }

  onMediaLibrary() {
    this.setState({ fileSelectorOpen: true });
  }

  onMediaLibraryClose() {
    this.setState({ fileSelectorOpen: false });
  }

  openDownload(event) {
    this.refs.dropZone.open();
    event.stopPropagation();
    event.preventDefault();
  }

  changeCaption(e) {
    const edit = {
      ...this.state.edit,
      caption: e.target.value
    };
    this.setState({ edit });
  }

  saveOnBlur() {
    Message.info(this.context.getIntlMessage('video.changesSaved'));
    this.save(false);
  }

  allowDownloading = (event, allowDownloading) => {
    this.setState(
      {
        edit: {
          ...this.state.edit,
          allowDownloading
        }
      },
    );
  };

  getModuleData(content, data) {
    return {
      caption: this.state.edit.caption,
      allowDownloading: this.state.edit.allowDownloading,
      fileId: this.state.edit.fileId || data.fileId,
      external: this.state.edit.external
    };
  }

  embed() {
    const url = this.refs.embedUrl.value;
    const edit = {
      ...this.state.edit
    };

    if (url !== '') {
      const provider = Media.getProviderFromUrl(url);
      if (provider) {
        if (provider.provider === 3) {
          SoundCloud.oEmbed(url, response => {
            provider.id = response.html;
            edit.external = provider;
            this.setState({ edit });
            this.autoSave();
          });
        } else {
          edit.external = provider;
          this.setState({ edit });
          this.autoSave();
        }
      } else {
        this.cannotSave();
      }
    }
  }

  attach(data) {
    if (data.length && data.length > 0) {
      const file = data[0].file;
      const sources = supportedExtensions.map(extension => {
        return { url: file.url.replace(
              /deathstar\.s\.coursio\.com\/files/i,
              'coursio.s3-eu-west-1.amazonaws.com'),
               type: extension };
      });
      const edit = {
        ...this.state.edit,
        external: null,
        fileId: file.id,
        sources
      };
      this.setState({ edit });
      this.getModuleData()
      this.pollApiForJobId(file.id);
      if (!this.state.pollProgress) {
        this.setState({ progress: 0.45, pollProgress: true });
      }
    }
  }

  cannotSave() {
    if (this._timer) {
      clearTimeout(this._timer);
    }

    this._timer = setTimeout(() => {
      Message.info(this.context.getIntlMessage('video.changesCannotBeSaved'));
      this._timer = null;
    }, 1000);
  }

  pollApiForJobId(fileId) {
    setTimeout(() => {
      const now = new Date();
      this.apiPollerStart = this.apiPollerStart || new Date();
      if (now - this.apiPollerStart < 100000) {
        SteelCompass.call('file', 'getJobId', { fileId: fileId }, async response => {
          const data = response.data;
          // Poll encoding progress
          if (data && data.jobId && data.accessKey) {
            await this.pollZencForProgress(data.jobId, data.accessKey);
            if (!this.state.pollProgress) {
              this.setState({ progress: 0, pollProgress: true });
            }
          } else {
            // Keep polling for jobId
            this.pollApiForJobId(fileId);
          }
        });
      } else {
        // Reset polling
        this.apiPollerStart = null;
      }
    }, 3500);
  }

  pollZencForProgress(jobId, accessKey) {
    setTimeout(async () => {
      const now = new Date();
      this.zencPollerStart = this.zencPollerStart || new Date();
      if (
          now - this.zencPollerStart < 1000000 ||
          (this.encodingProgress > 0 && this.encodingProgress < 100)
      ) {
        const response = await SuperAgent.get(
            Config.zenCoderRoot +
            'jobs/' +
            jobId +
            '/progress.json?api_key=' +
            accessKey
        )
            .set('Content-Type', 'text/plain')
        const data = (response && JSON.parse(response.text)) || {};
        // Data object should contain a state and a progress property if the state is still processing.
        if (data.state === 'processing' && data.progress) {
          if (data.progress > this.state.progress) {
            this.setState({ progress: data.progress });
          }
          await this.pollZencForProgress(jobId, accessKey);
        } else if (data.state === 'finished') {
          // Stop the polling
          const sources = this.state.edit.sources.map(source => {
            return {
              ...source,
              url: source.url.replace(
                  /deathstar\.s\.coursio\.com\/files/i,
                  'coursio.s3-eu-west-1.amazonaws.com'
              )
            };
          });
          this.setState({
            progress: 100,
            pollProgress: false,
            edit: {
              ...this.state.edit,
              sources
            }
          });
          Message.info(
              this.context.getIntlMessage('media.encodingComplete')
          );
        }
      } else {
        // Reset polling
        this.zencPollerStart = null;
        this.autoSave();
      }
    }, 2000)
  }

  renderEditMode() {
    const { sources, external, caption, allowDownloading } = this.state.edit;
    let video;

    // let pollProgress;
    // if (this.state.pollProgress) {
    //   pollProgress = <CircularProgress style={{ height: Spacing.desktopKeylineIncrement / 4 }} progressColor={this.context.muiTheme.rawTheme.palette.primary2Color} progress={this.state.progress} size={2} />;
    // }

    const uploadLink = (
      <a onTouchTap={::this.openDownload}>
        {this.context.getIntlMessage('module.upload')}
      </a>
    );
    const libraryLink = (
      <a onTouchTap={::this.onMediaLibrary}>
        {this.context.getIntlMessage('module.library')}
      </a>
    );
    if (
      this.state.pollProgress ||
      (this.state.progress > 0 && this.state.progress < 100)
    ) {
      video = (
        <div>
          <CircularProgress
            progressColor={this.context.muiTheme.rawTheme.palette.primary1Color}
            progress={this.state.progress}
            size={2}
          />
          <div>
            {this.state.pollProgress
              ? this.context.getIntlMessage('media.encoding')
              : this.context.getIntlMessage('media.uploading')}
          </div>
        </div>
      );
    } else if (
      (sources && sources.length > 0) ||
      (external && external.provider)
    ) {
      if (external && external.provider) {
        video = <Embed params={external} />;
      } else {
        video = <VideoPlayer sources={sources} />;
      }
    } else {
      video = <Icons.AvMovie style={dropZoneStyles.icon} />;
    }

    return (
      <div>
        <div style={dropZoneStyles.moduleContainer}>{video}</div>
        <DropZone
          accept="video/*"
          ref="dropZone"
          style={dropZoneStyles.dropZone}
          lineHeight={Spacing.desktopKeylineIncrement / 2}
          onProgress={::this.progress}
          onSuccess={::this.attach}
        >
          <div style={dropZoneStyles.header}>
            {this.context.getIntlMessage('module.dropVideo')}
          </div>
          <div style={dropZoneStyles.subHeader}>
            <FormattedMessage
              message={this.context.getIntlMessage('module.uploadOrBrowse')}
              upload={uploadLink}
              library={libraryLink}
            />
          </div>
          <div style={dropZoneStyles.subHeader}>
            {this.context.getIntlMessage('module.or')}
          </div>
          <Paper style={dropZoneStyles.import.root}>
            <FlexBox>
              <FlexBox>
                <input
                  ref="embedUrl"
                  style={dropZoneStyles.import.input}
                  type="text"
                  placeholder={this.context.getIntlMessage('video.embed')}
                  onChange={::this.embed}
                />
              </FlexBox>
            </FlexBox>
          </Paper>

          <TextField
            fullWidth
            hintText={this.context.getIntlMessage('Caption')}
            value={caption}
            onChange={::this.changeCaption}
            onBlur={::this.saveOnBlur}
          />
        </DropZone>
        <div className={css.toggleWrapper}>
          <Toggle
            name={'allowDownloading'}
            value={'allowDownloading'}
            labelPosition={'right'}
            defaultToggled={allowDownloading}
            label={this.context.getIntlMessage('video.allowDownloading')}
            onToggle={this.allowDownloading}
          />
        </div>
        <FileSelectorDialog
          type="video"
          open={this.state.fileSelectorOpen}
          onSelect={::this.selectMedia}
          onClose={::this.onMediaLibraryClose}
        />
      </div>
    );
  }

  renderDetailMode() {
    const { sources, caption, external, allowDownloading } = this.state.edit;
    let video;
    if (external && external.provider) {
      video = <Embed params={external} />;
    } else if (sources && sources.length > 0) {
      video = <VideoPlayer sources={sources} gaTacking={this.props.gaTacking} />;
    } else {
      video = (
        <div style={dropZoneStyles.dropZone}>
          <div style={dropZoneStyles.moduleContainer}>
            <Icons.AvMovie style={dropZoneStyles.icon} />
            <br />
            {this.context.getIntlMessage('module.uploadVideo')}
          </div>
        </div>
      );
    }
    return (
      <div ref="root" style={{ marginBottom: 42 }}>
        {video}
        <figcaption>{caption}</figcaption>
        {allowDownloading && (
          <div className={css.videoDownload}>
            {this.context.getIntlMessage('video.download')}
            {this.props.sources.map(source => {
              const extension = source.data.split('.').pop();
              return (
                <a
                  key={extension}
                  className={css.downloadLink}
                  target={'_blank'}
                  href={`${location.protocol}${source.downloadable}`}
                >
                  {extension}
                </a>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

export default VideoModule;



// WEBPACK FOOTER //
// ./src/js/components/Page/Module/Video.js